import { render, staticRenderFns } from "./AppSignupOneTimePassPane.vue?vue&type=template&id=1a38f48d&scoped=true"
import script from "./AppSignupOneTimePassPane.vue?vue&type=script&lang=ts"
export * from "./AppSignupOneTimePassPane.vue?vue&type=script&lang=ts"
import style0 from "./AppSignupOneTimePassPane.vue?vue&type=style&index=0&id=1a38f48d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a38f48d",
  null
  
)

export default component.exports